define('ItemPDF.Model', ['SCModel', 'Utils'], function (SCModelComponent, Utils) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;

  function ItemPDFModel() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ItemPDF.Service.ss'));
    };
  }

  ItemPDFModel.prototype = Object.create(SCModel.prototype);

  ItemPDFModel.prototype.constructor = ItemPDFModel;

  return ItemPDFModel;
});
